import React from 'react';
// @ts-ignore
import Plot from 'react-plotly.js';
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import { Theme, WithTheme } from '@material-ui/core';
import createStyles from '@material-ui/core/styles/createStyles';
import Grid from '@material-ui/core/Grid';
import { QRLabelMapJSON } from '../../Quantification/QuantificationResultJSON';
import NodeLabel from "../../NodeLabel/NodeLabel";

const styles = (theme: Theme) => createStyles({
	plotRoot: {
		width: '100%',
		margin: 0,
		background: 'unset',
	},
	plotPaper: {
		overflow: 'hidden',
		marginBottom: theme.spacing(1),
	},
	root: {
		flexGrow: 1,
	},
});

interface Props extends WithStyles<typeof styles>, WithTheme {
	data: TableCellData[];
	map: QRLabelMapJSON;
}

interface TableCellData {
	"Conditional Before": number;
	"Conditional After": number;
	"Criticality Before": number;
	"Criticality After": number;
	"Diagnostic Before": number;
	"Diagnostic After": number;
	"Marginal Before": number;
	"Marginal After": number;
	"Potential Before": number;
	"Potential After": number;
	"RAW Before": number;
	"RAW After": number;
	"RRW Before": number;
	"RRW After": number;
	basic_event: string;
	scenario: string;
}

/**
 * SingleHCL quantification result
 * This is an Alternate View to supplement the existing table view of the importance measures
 * This will provide a visual representation of comparisons of the importance computed by each method between all basic events
 */

class ImportanceMeasureComparisonPlot extends React.Component<Props> {
	constructor(props: Props) {
		super(props);
	}

	private getColor = (param, compParam, type) => {
		let color;
		if (param !== null || param !== undefined) {
			color = 'rgba(129, 199, 132, 0.66)';
			if(type === "Success" && param < compParam){
				color = 'rgba(229, 115, 115, 0.66)';
			}
			if(type === "Failure" && param > compParam){
				color = 'rgba(229, 115, 115, 0.66)';
			}
			if(param == compParam){
				color = 'rgba(201, 199, 199,0.66)';
			}
		}

		return color;
	}

	private buildPlot = (title: string, compTitle: string) => {
		const { data, theme, map } = this.props;
		return (
			<Grid item xs={12} sm={3}>
				<Plot
					style={{ width: '100%' }}
					data={[
						{
							type: 'bar',
							x: data.map((row: TableCellData) => {
								try {
									return map[row.basic_event].label.name;
								} catch (e) {
									console.error(e);
									return 'Undefined';
								}
							}),
							// @ts-ignore
							y: data.map((row: TableCellData) => row[title]),
							marker: {
								color: data.map((row: TableCellData) => this.getColor(row[title], row[compTitle], NodeLabel.buildWithDefaults(map, row.endstate).label.name)),
								line: {
									width: 2,
								},
							},
						},
					]}
					config={{
						displaylogo: false,
						autosizable: true,
						responsive: true,
					}}
					layout={{
						title,
						paper_bgcolor: 'transparent',
						plot_bgcolor: 'transparent',
						font: {
							color: theme.palette.text.primary,
							family: theme.typography.fontFamily,
							size: theme.typography.fontSize,
						},
						xaxis: {
							color: theme.palette.text.secondary,
							gridcolor: theme.palette.text.secondary,
						},
						yaxis: {
							color: theme.palette.text.secondary,
							gridcolor: theme.palette.text.secondary,
						},
						// width: 400,
						height: 400,
						margin: {
							t: 35,
							b: 125,
							l: 25,
							r: 15,
						},
					}}
				/>
			</Grid>
		);
	};

	render() {
		const { classes } = this.props;
		return (
			<div className={classes.root}>
				<Grid container spacing={10}>
					{this.buildPlot('Conditional Before', 'Conditional After')}
					{this.buildPlot('Conditional After', 'Conditional Before')}
					{this.buildPlot('Marginal Before', 'Marginal After')}
					{this.buildPlot('Marginal After', 'Marginal Before')}
					{this.buildPlot('Potential Before', 'Potential After')}
					{this.buildPlot('Potential After', 'Potential Before')}
					{this.buildPlot('Diagnostic Before', 'Diagnostic After')}
					{this.buildPlot('Diagnostic After', 'Diagnostic Before')}
					{this.buildPlot('RAW Before', 'RAW After')}
					{this.buildPlot('RAW After', 'RAW Before')}
					{this.buildPlot('RRW Before', 'RRW After')}
					{this.buildPlot('RRW After', 'RRW Before')}
					{this.buildPlot('Criticality Before', 'Criticality After')}
					{this.buildPlot('Criticality After', 'Criticality Before')}
				</Grid>
			</div>
		);
	}
}

export default withStyles(styles, { withTheme: true })(ImportanceMeasureComparisonPlot);
